import { createSearchParams } from 'react-router-dom';
import { getClaimsDashboardPrefilter } from './claimsDashboardPrefilters';
import { withDashboardBreadcrumbOrigin } from './breadcrumbNavigation';

/**
 * Navigate to the claims list with query/state derived from dashboard chart keys.
 */
export function navigateClaimsFromDashboardFilter(navigate, claimsDashboardFilter) {
  const prefilter = getClaimsDashboardPrefilter(claimsDashboardFilter);
  const params = {};
  if (prefilter?.selectedFileStatus?.length) {
    params.claimStatus = prefilter.selectedFileStatus.join(',');
  }
  if (prefilter?.selectedAppType?.length) {
    params.appType = prefilter.selectedAppType.join(',');
  }
  const search = createSearchParams(params).toString();
  navigate(search ? `/property/claims?${search}` : '/property/claims', {
    state: withDashboardBreadcrumbOrigin({ claimsDashboardFilter }),
  });
}
